/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_One_Half_HoursInputs */

const en_onboarding_results_one_half_hours = /** @type {(inputs: Onboarding_Results_One_Half_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1.5 hours`)
};

const es_onboarding_results_one_half_hours = /** @type {(inputs: Onboarding_Results_One_Half_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1.5 horas`)
};

/**
* | output |
* | --- |
* | "1.5 hours" |
*
* @param {Onboarding_Results_One_Half_HoursInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_one_half_hours = /** @type {((inputs?: Onboarding_Results_One_Half_HoursInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_One_Half_HoursInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_one_half_hours(inputs)
	return en_onboarding_results_one_half_hours(inputs)
});